import React from "react";
import moment from "moment";
import { ENROLLMENT_STATUS } from "utils/constants";
import CreditProfile from "./CreditProfile";
import CreditScore from "./CreditScore";
import CreditFactors from "./CreditFactors";
import CreditReportDispute from "./CreditReportDispute";
import { CreditMonitoringErrorBox } from "./ErrorBox";

/**
 * @param {Object} props
 * @param {string} props.status
 * @param {Object} props.creditScoreSummary
 * @param {Function} props.setStatus
 * @param {Date | null} props.lockedAt
 * @returns
 */
const CreditMonitoring = (props) => {
  const { creditScoreSummary, setStatus, status, lockedAt } = props;
  const latestCreditScore = creditScoreSummary?.credit_scores[0];
  const isBlurred = status !== ENROLLMENT_STATUS.ENROLLED;
  const userCanEnroll = status === ENROLLMENT_STATUS.ELIGIBLE;
  const isUserLockedOut = status === ENROLLMENT_STATUS.LOCKED;
  const nextAttemptDate = lockedAt ? moment(lockedAt).add("30", "days").toDate() : null;

  return (
    <div className="flex flex-col items-center py-2.5 md:flex-row md:items-start">
      <div className="flex flex-col w-full">
        <CreditScore
          className="shadow rounded-lg w-full"
          creditScore={latestCreditScore}
          isBlurred={isBlurred}
          isEnrollable={userCanEnroll}
          onEnrollClick={() => setStatus(ENROLLMENT_STATUS.WAITING)}
        />
        <CreditMonitoringErrorBox
          className="mt-10 md:mt-6"
          title="Verification limit reached"
          message={
            <>
              You’ve reached the verification attempt limit. Please try again
              after
              <span className="font-bold">{` ${new Date(nextAttemptDate)?.toDateString()} `}</span>
              or contact support.
            </>
          }
          isVisible={isUserLockedOut}
          nextAttemptDate={nextAttemptDate}
        />
      </div>
      <div className="flex flex-col ml-0 mt-6 md:mt-0 md:ml-6">
        <CreditProfile
          className="shadow rounded-lg"
          creditScore={latestCreditScore}
          isBlurred={isBlurred}
        />
        <CreditFactors className="mt-8 md:mt-6 shadow rounded-lg bg-white" />
        <CreditReportDispute className="mt-8 md:mt-6 shadow rounded-lg bg-white" />
      </div>
    </div>
  );
};

export default CreditMonitoring;
